import type { SVGProps } from "react";

const CheckboxIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<rect x="2" y="2" width="16" height="16" rx="5.25" fill="white" stroke="#3F3F46" stroke-width="1.5" />
			<path d="M6.25 10.375L9.25 13.375L13.75 6.625" stroke="#3F3F46" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	);
};

export default CheckboxIcon;
